import React from "react";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./BackToStageButton.scss";

const BackToStageButton = ({ handleBackToStage, active = true }) => {
  return (
    <div className="btn-back-wrapper">
      <IconButton
        className={`btn btn-back btn-sm ${active ? " active" : ""}`}
        onClick={handleBackToStage}
        aria-pressed={active}
        size="small"
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default BackToStageButton;
